import React from "react";
import {connect} from "react-redux";
import {Avatar, Dropdown, Menu} from "antd";
import styles from "./style.module.scss";
import {Link} from "react-router-dom";
import {UserOutlined} from "@ant-design/icons";

@connect(({user}) => ({user}))
class ProfileMenu extends React.Component {
    logout = () => {
        const {dispatch} = this.props;
        dispatch({
            type: "user/LOGOUT"
        });
    };

    render() {
        const {user} = this.props;
        const menu = (
            <Menu selectable={false}>
                <Menu.Item>
                    <strong>{user.name || "Anonymous"}</strong>
                </Menu.Item>
                <Menu.Divider/>
                <Menu.Item>
                    <div>
                        <strong>Phone: </strong>
                        {user.mobile || "— "}
                    </div>
                </Menu.Item>
                <Menu.Divider/>
                <Menu.Item>
                    <Link to="/profile">
                        <i className={"${styles.menuIcon} icmn-profile"}/>
                        Profile
                    </Link>
                </Menu.Item>
                <Menu.Divider/>
                <Menu.Item>
                    <a href="javascript: void(0);" onClick={this.logout}>
                        <i className={"${styles.menuIcon} fe fe-log-out"}/>
                        Logout
                    </a>
                </Menu.Item>
            </Menu>
        );
        return (
            <Dropdown overlay={menu}>
                <div className={styles.dropdown}>
                    <Avatar
                        className={styles.avatar}
                        shape="square"
                        size="large"
                        icon={<UserOutlined/>}
                    />
                </div>
            </Dropdown>
        );
    }
}

export default ProfileMenu;
